import API from 'utils/API';
import { AppLinkType } from './components/AppLink';
import { IPlatformSectionProps } from './components/PlatformSection';
import iosApp from './images/ios-app.png';
import androidApp from './images/android-app.png';
import webApp from './images/web-app.png';
import macApp from './images/mac-app.png';
import windowsApp from './images/windows-app.png';
import integratedCharts from '../Home/HomeContent/images/integrated-charts.png';
import advancedQuotes from './images/advanced-quotes.png';
import stayInLoop from '../Home/HomeContent/images/stay-in-loop.png';
import rapidOrderEntry from './images/rapid-order-entry.png';
import efficientOverview from './images/efficient-overview.png';
import indepthCharting from './images/indepth-charting.png';
import paperTrading from './images/paper-trading.png';
import professionalTools from './images/professional-tools.png';
import smartTrading from './images/smart-trading.png';

interface PlatformType {
    header: {
        appLink: Array<{ type: AppLinkType; imgSrc: string; url: string }>;
    };
    section: IPlatformSectionProps[];
}

const PlatformSectionConfig: PlatformType = {
    header: {
        appLink: [
            { type: 'ios', imgSrc: iosApp, url: 'https://apps.apple.com/app/tradeup-international/id1492602577' },
            {
                type: 'android',
                imgSrc: androidApp,
                url: 'https://play.google.com/store/apps/details?id=com.tigerbrokers.tigertradeintl&hl=en'
            },
            {
                type: 'mac',
                imgSrc: macApp,
                url: 'https://d.tradeup.com/download/pc/TradeUP_7.4.0.dmg'
            },
            {
                type: 'win',
                imgSrc: windowsApp,
                url: 'https://d.tradeup.com/download/pc/TradeUPSetup_7.4.0.0.exe'
            },
            {
                type: 'web',
                imgSrc: webApp,
                url: API.PC.host()
            }
        ]
    },
    section: [
        {
            header: 'Mobile Trading',
            content:
                'TradeUP’s mobile app is a cutting-edge and intuitive trading platform for on-the-go traders. Get access to a suite of powerful tools and features right at your fingertips with a one-tap trading experience.'
        },
        {
            header: 'Integrated Charts',
            content:
                'Analyze the market using our powerful and interactive charts with real-time quotes, on-the-fly indicators, and customizable views.',
            hasHeaderUnderline: true,
            imgSrc: integratedCharts,
            imgLocation: 'left'
        },
        {
            header: 'Advanced Quotes',
            content:
                'Stay on top of the market with real-time prices on a broader range of bids and asks. A depth chart is also included to help you identify supply and demand at a glance.',
            hasHeaderUnderline: true,
            imgSrc: advancedQuotes,
            imgLocation: 'right'
        },
        {
            header: 'Stay in the Loop',
            content:
                'Keep an eye on your portfolio or listings of interest with custom watchlists. Navigate market trends with custom alerts, screeners, economic calendars, and streaming news.',
            hasHeaderUnderline: true,
            imgSrc: stayInLoop,
            imgLocation: 'left'
        },
        {
            header: 'Desktop Platform',
            content:
                'TradeUP -- Sized Up! Our PC version is now available! Enjoy your favorite trading app on the big screen.',
            largeMargin: true
        },
        {
            header: 'User friendly Mobile Trading APP',
            content: 'Extensive suite of indicators and drawing tools to help you analyze the market.',
            hasHeaderUnderline: true,
            imgSrc: professionalTools,
            imgHeight: 350,
            imgLocation: 'left',
            pcImg: true,
            className: 'platform-pc-root'
        },
        {
            header: 'Smart Trading',
            content: 'Seize market opportunities with extensive real-time insights and Level 2 data.',
            hasHeaderUnderline: true,
            imgSrc: smartTrading,
            imgHeight: 350,
            imgLocation: 'right',
            pcImg: true,
            className: 'platform-pc-root'
        },
        {
            header: 'Web Platform',
            content:
                'Our online trading platform provides a wide array of tools and resources for you to trade with ease. You can keep tabs on the market, place orders, and monitor your positions all in one place.',
            largeMargin: true
        },
        {
            header: 'Rapid Order Entry',
            content:
                'Streamline your trading process with our instant order entry feature and submit an order without filling up the order placement page.',
            hasHeaderUnderline: true,
            imgSrc: rapidOrderEntry,
            imgLocation: 'left',
            float: true,
            imgHeight: 432,
            pcImg: true
        },
        {
            header: 'Efficient Overview of the Market ',
            content:
                'Seize potential opportunities at a glance with access to color-coded heat maps where you can easily visualize market activity sorted by industry.',
            hasHeaderUnderline: true,
            imgSrc: efficientOverview,
            imgLocation: 'right',
            float: true,
            imgHeight: 583,
            pcImg: true
        },
        {
            header: 'In-depth Charting and Analysis',
            content:
                'Get insights from advanced intraday and historical charting with 30+ drawing tools, indicators, and real-time quotes.',
            hasHeaderUnderline: true,
            imgSrc: indepthCharting,
            imgLocation: 'left',
            float: true,
            imgHeight: 569,
            pcImg: true
        },
        {
            header: 'Paper Trading',
            content:
                'Learn the tools or refine your strategy without risk anytime with paper trading. Get set up with virtual cash and make trades based on live market data.',
            hasHeaderUnderline: true,
            imgSrc: paperTrading,
            imgLocation: 'right',
            imgHeight: 380,
            pcImg: true
        }
    ]
};

export { PlatformSectionConfig };
